/* eslint-disable camelcase */
/* eslint-disable no-useless-escape */
/* eslint-disable no-script-url */
/* eslint-disable indent */
import React from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import TextInput from '@techsoftware/happay-widgets/TextInput';
import FileUpload from '@techsoftware/happay-widgets/FileUpload';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import RadioGroup from '@techsoftware/happay-widgets/RadioGroup';
import Grid from '@techsoftware/happay-widgets/Grid';
import Spinner from '@techsoftware/happay-widgets/Spinner';
import Dropdown from '@techsoftware/happay-widgets/Dropdown';
import PropTypes from 'prop-types';
import BottomActions from '../bottomActions';
import GenericHeader from '../../containers/GenericHeaderContainer';
import { debounce } from '../../constants/throttleDebounce';
import VendorDetailedView from './vendorDetailedView';
import ActionConfirmation from '../ActionConfirmation';
import VendorShimmer from './VendorShimmer';
import Declaration from '../customComponent/declaration';
import OCRImage from '../../assets/images/p-icon-ocr.svg';

const OCRImg = <img src={OCRImage} className="height-18" alt="ocr-scanned" />;
export default class CreateVendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      identificationId: '',
      panNo: '',
      gstFetched: 'not_fetched',
      isVendorRegistered: true,
      displayName: '',
      registeredName: '',
      address: '',
      city: {},
      states: '',
      pincode: '',
      emailId: '',
      contactPerson: '',
      contactNumber: '',
      beneficiaryName: '',
      bankAccNumber: '',
      confirmBankAccNumber: '',
      ifscNumber: '',
      declaration: false,
      openDialogbox: false,
      isIfscCorrect: false,
      shimmer: false,
      ocrDetails: {
        ocrBeneficiaryName: '',
        ocrBankAccNumber: '',
        ocrConfirmBankAccNumber: '',
        ocrIfscNumber: '',
      },
      vendorError: {
        identificationIdErr: '',
        displayNameErr: '',
        registeredNameErr: '',
        panNoErr: '',
        pincodeErr: '',
        addressErr: '',
        cityErr: '',
        stateErr: '',
        contactPersonErr: '',
        contactNumberErr: '',
        emailIdErr: '',
        beneficiaryNameErr: '',
        bankAccNumberErr: '',
        confirmBankAccNumberErr: '',
        ifscNumberErr: '',
        fileErr: false,
      },
      file: {
        oldFiles: [],
        newFiles: [],
        deletedFiles: [],
      },
      countryCode: '',
      cityText: '',
      showCancelConfirmation: false,
    };
    this.autocompleteSearchCityOnlyThrottled = debounce(
      this._autocompleteSearchCityOnly,
      500,
    );
  }

  componentDidMount() {
    const {
      getCountryCodes,
      getVendorDetails,
      getWorkVendorFlowDetails,
      match: { params: { vendorId } = {} } = {},
      location: { state = {} },
    } = this.props;

    this.handlePreventCopyPaste('acc-no');
    this.handlePreventCopyPaste('confirm-acc-no');
    getCountryCodes({});
    if (vendorId) {
      if (state.urlType) {
        const params = {};
        if (state.urlType === 'RESOURCE_DETAILS') {
          params.container = state.containerType;
          params.resource_id = vendorId;
        }
        getWorkVendorFlowDetails({ id: vendorId, url: state.urlType, params });
      } else {
        getVendorDetails({ id: vendorId });
      }
    }
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  componentWillUnmount() {
    const { setVendorDetails } = this.props;
    setVendorDetails({});
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      vendorList = {},
      gstFetchedFailed,
      editVendorDetails,
      ocrData = {},
      cityState = [],
    } = this.props;
    const { cityState: prevCityState = [] } = prevProps;
    const { vendorError, searchCity } = this.state;
    const {
      vendor_name = '',
      identification_id = '',
      pincode = '',
      address = '',
      city_name = '',
      state = '',
    } = vendorList;
    if (prevProps.gstFetchedFailed !== gstFetchedFailed && gstFetchedFailed) {
      this.setState({
        gstFetched: 'fetch_failed',
      });
    } else if (
      prevProps?.vendorList?.identification_id !==
        vendorList?.identification_id ||
      (prevState.isVendorRegistered !== this.state.isVendorRegistered &&
        this.state.isVendorRegistered &&
        this.state.identificationId)
    ) {
      this.setState({
        gstFetched: 'fetched',
        registeredName: vendor_name,
        identificationId: identification_id,
        pincode,
        address,
        city: city_name,
        states: state,
        panNo:
          identification_id?.length === 15
            ? identification_id?.substring(2, 12)
            : identification_id,
        vendorError: {
          ...vendorError,
          registeredNameErr: '',
          pincodeErr: '',
          addressErr: '',
          cityErr: '',
          panNoErr: '',
        },
      });
    } else if (
      prevProps?.editVendorDetails?.vendor_id !== editVendorDetails?.vendor_id
    ) {
      const {
        is_gstin_flow,
        display_name = '',
        vendor_name = '',
        identification_id = '',
        pincode = '',
        address = '',
        city = '',
        state = '',
        contact_name = '',
        mobile_number = '',
        email_id = '',
        bank_details = {},
      } = editVendorDetails;
      const {
        beneficiary_name = '',
        account_number = '',
        ifsc_code = '',
        cancelled_cheque_copy = '',
      } = bank_details;
      this.setState({
        isVendorRegistered: is_gstin_flow,
        gstFetched: is_gstin_flow ? 'fetched' : 'not_fetched',
        identificationId: is_gstin_flow ? identification_id : '',
        displayName: display_name,
        registeredName: vendor_name,
        panNo:
          identification_id?.length === 15
            ? identification_id?.substring(2, 12)
            : identification_id,
        pincode,
        address,
        city,
        states: state,
        contactPerson: contact_name,
        contactNumber: mobile_number,
        emailId: email_id,
        beneficiaryName: beneficiary_name,
        bankAccNumber: account_number,
        confirmBankAccNumber: account_number,
        // ifscNumber: ifsc_code,
        file: {
          oldFiles:
            cancelled_cheque_copy.length > 0 ? [cancelled_cheque_copy] : [],
          newFiles: [],
          deletedFiles: [],
        },
        searchCity: false,
      });
      this.handleIfsc(event, ifsc_code, true);
    } else if (
      JSON.stringify(ocrData) !== JSON.stringify(prevProps.ocrData || {}) &&
      Object.keys(ocrData).length > 0
    ) {
      const {
        account_number = '',
        beneficiary_name = '',
        cheque_url = '',
        ifsc_code = '',
      } = ocrData || {};
      const {
        bankAccNumber,
        ifscNumber,
        beneficiaryName,
        confirmBankAccNumber,
      } = this.state;
      this.setState({
        ocrDetails: {
          ocrBankAccNumber: account_number,
          ocrIfscNumber: ifsc_code,
          ocrBeneficiaryName: beneficiary_name,
          ocrConfirmBankAccNumber: account_number,
        },
        bankAccNumber: bankAccNumber || account_number,
        // ifscNumber: ifscNumber || ifsc_code,
        beneficiaryName: beneficiaryName || beneficiary_name,
        // confirmBankAccNumber: confirmBankAccNumber || account_number,
        file: {
          oldFiles: cheque_url ? [cheque_url] : [],
          newFiles: [],
          deletedFiles: [],
        },
        shimmer: false,
      });
      this.handleIfsc(event, ifscNumber || ifsc_code, true);
    } else if (
      JSON.stringify(prevCityState) !== JSON.stringify(cityState) ||
      (cityState.length && searchCity)
    ) {
      this.setState({
        searchCity: false,
      });
    }
  }
  handleChange = (type, val, hideCancelPopup = false) => {
    const { vendorError } = this.state;
    vendorError[`${type}Err`] = '';
    this.setState({
      [type]: ['panNo', 'ifscNumber', 'identificationId'].includes(type)
        ? val.trim().toUpperCase()
        : val,
      showCancelConfirmation: !hideCancelPopup,
      gstFetched:
        type === 'identificationId' ? 'not_fetched' : this.state.gstFetched,
      vendorError,
    });
  };

  handleIfsc = (e, val, hideCancelPopup) => {
    const { getBankDetailsThroughIfsc } = this.props;
    const trimmedVal = val.trim().toUpperCase();
    if (trimmedVal.length === 11) {
      this.handleChange('ifscNumber', trimmedVal, hideCancelPopup);
      const isIfscValid = this.handleIfscValidation(trimmedVal);
      if (isIfscValid) {
        this.handleChange('isIfscCorrect', true, hideCancelPopup);
        getBankDetailsThroughIfsc({ ifsc_code: trimmedVal });
      }
    } else {
      this.handleChange('isIfscCorrect', false);
      this.handleChange('ifscNumber', trimmedVal);
    }
  };

  onUploadFile = (f, msg) => {
    if (f === false) {
      this.props.openSnackbar({
        message: msg,
        type: 'error',
      });
    } else {
      const { name } = f[0];
      const ext = name.split('.')[name.split('.').length - 1];
      const fileTypes = [
        'pdf',
        'heic',
        'jpg',
        'jpeg',
        'png',
        'tiff',
        'tif',
        'bmp',
      ];
      if (!fileTypes.includes(ext)) {
        this.props.openSnackbar({
          message: 'Unsupported file found',
          type: 'error',
        });
        return false;
      }
      const formData = new FormData();
      formData.append('cheque_attachments', 'cheque');
      formData.append('cheque', f[0]);
      this.props.getChequeDetails(formData, () => {
        this.handleOcrShimmer();
      });
      const { file, vendorError } = this.state;
      vendorError.fileErr = false;
      this.setState({
        vendorError,
        shimmer: true,
      });
    }
  };

  handleOcrShimmer() {
    this.setState({ shimmer: false });
  }

  onDeleteFile = (index, type) => {
    const { file } = this.state;
    const { ocrData } = this.props;
    const {
      account_number = '',
      beneficiary_name = '',
      cheque_url = '',
      ifsc_code = '',
    } = ocrData || {};
    const {
      bankAccNumber,
      ifscNumber,
      beneficiaryName,
      confirmBankAccNumber,
    } = this.state;
    if (type === 'newFiles') {
      file.newFiles.splice(index, 1);
    } else if (type === 'oldFiles') {
      file.oldFiles.splice(index, 1);
    }

    this.setState(
      {
        file,
        ocrDetails: {
          ocrBeneficiaryName: '',
          ocrBankAccNumber: '',
          ocrConfirmBankAccNumber: '',
          ocrIfscNumber: '',
        },
        bankAccNumber: bankAccNumber === account_number ? '' : bankAccNumber,
        beneficiaryName:
          beneficiaryName === beneficiary_name ? '' : beneficiaryName,
        confirmBankAccNumber:
          confirmBankAccNumber === account_number ? '' : confirmBankAccNumber,
        ifscNumber: ifscNumber === ifsc_code ? '' : ifscNumber,
      },
      () => this.props.setChequeDetails({}),
    );
  };

  handleFetchGST = () => {
    const { identificationId, isVendorRegistered } = this.state;
    const { vendorList = {} } = this.props;
    if (identificationId !== vendorList.identification_id) {
      this.setState({
        gstFetched: 'fetching',
      });
      setTimeout(() => {
        let payload = {};
        payload[isVendorRegistered ? 'gstin' : 'pan'] = identificationId;
        this.props.getGstinDetails({ ...payload });
      });
    } else {
      this.setState({ gstFetched: 'fetched' });
    }
  };

  handleVendorRegisteration = val => {
    let obj = this.state;

    if (val && obj.identificationId) {
      setTimeout(() => {
        this.props.getGstinDetails({ gstin: obj.identificationId });
      });
    } else {
      obj = {
        ...obj,
        identificationId: '',
        gstFetched: 'not_fetched',
        panNo: '',
        vendorError: {},
        identificationId: '',
        displayName: '',
        registeredName: '',
        address: '',
        city: {},
        states: '',
        pincode: '',
        emailId: '',
        contactPerson: '',
        contactNumber: '',
        beneficiaryName: '',
        bankAccNumber: '',
        confirmBankAccNumber: '',
        ifscNumber: '',
        declaration: false,
        isIfscCorrect: false,
        ocrDetails: {
          ocrBeneficiaryName: '',
          ocrBankAccNumber: '',
          ocrConfirmBankAccNumber: '',
          ocrIfscNumber: '',
        },
        file: {
          oldFiles: [],
          newFiles: [],
          deletedFiles: [],
        },
        countryCode: '',
        cityText: '',
      };
    }
    this.setState({
      ...obj,
      isVendorRegistered: val,
      // city: !val ? '' : this.state.city,
      // states: !val ? '' : this.state.states,
    });
  };

  getHeaderConfig = () => {
    const {
      match: { params: { viewType } = {} } = {},
      editVendorDetails: { editable } = {},
    } = this.props;

    const obj = {};

    if (viewType === 'detail' && editable) {
      obj.edit = {
        name: '',
        id: 11,
        type: 'edit',
      };
    }
    if (viewType === 'detail' && editable) {
      obj.delete = {
        name: '',
        id: 11,
        type: 'delete',
      };
    } else {
      obj.limitInfo = {
        name: '',
        id: 11,
        type: 'limitInfo',
      };
    }
    return obj;
  };

  onButtonClick = (event, type) => {
    const { history, match: { params: { vendorId } = {} } = {} } = this.props;
    if (type.type === 'crossButton') {
      history.goBack();
    } else if (type.type === 'edit') {
      history.push({
        pathname: `/vendor/myvendor/editVendor/${vendorId}`,
      });
    } else if (type.type === 'delete') {
      this.setState({ openDialogbox: true });
    }
  };

  handleDialogActionClick = val => {
    const {
      updateVendorDetails,
      match: { params: { vendorId } = {} } = {},
      editVendorDetails: { vendor_id } = {},
    } = this.props;

    const finalObj = new FormData();
    finalObj.append('id', vendor_id);
    if (val === 'Deactivate') {
      finalObj.append('deactivate_flag', true);
    } else if (val === 'Activate') {
      finalObj.append('reactivate_flag', true);
    } else {
      finalObj.append('delete_flag', true);
      this.setState({ openDialogbox: false });
    }
    updateVendorDetails(finalObj);
  };

  drawCardUI = (cardTitle, cardIndex, cardContent) => (
    <Grid
      container
      className="border-container-imp white-bg border-radius-4 margin-b-20"
    >
      <Grid item className="payment-card-title border-b">
        <div className="d-flex padding-lr-30 padding-tb-20">
          <span className="rounded-indexing margin-r-10">{cardIndex}</span>{' '}
          <div className="fw-500 vendor-card-title">{cardTitle}</div>
        </div>
      </Grid>
      <Grid item>{cardContent}</Grid>
    </Grid>
  );

  handleScroll = id => {
    const element = document.querySelector(id);
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  };

  checkValidation = typeOfAction => {
    const {
      isVendorRegistered,
      gstFetched,
      identificationId,
      displayName,
      registeredName,
      panNo,
      pincode,
      address,
      contactPerson,
      contactNumber,
      emailId,
      beneficiaryName,
      bankAccNumber,
      confirmBankAccNumber,
      ifscNumber,
      city,
      cityText,
      file: { newFiles = [], oldFiles = [] },
      declaration,
      vendorError,
    } = this.state;
    let checkPass = true;
    let errorEle = null;
    const pinRegex = /^[1-9][0-9]{5}$/;
    const emailRegex = /^([a-zA-Z0-9-_\.\+]+)@([a-zA-Z0-9-_]+)\.([a-zA-Z]{2,6})(\.[a-zA-Z]{2,6})?$/;
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    const panNoRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    const accNoMatchFail = !!(
      bankAccNumber &&
      confirmBankAccNumber &&
      bankAccNumber !== confirmBankAccNumber
    );
    if (!declaration && typeOfAction !== 'Save') {
      errorEle = '#vendor-declaration';
      vendorError.declarationErr = true;
      checkPass = false;
    }
    if (newFiles.length === 0 && oldFiles.length === 0) {
      vendorError.fileErr = true;
      errorEle = '#vendor-file-upload';
      checkPass = false;
    }
    if (!ifscNumber || !ifscRegex.test(ifscNumber)) {
      vendorError.ifscNumberErr = 'Please enter a valid IFSC';
      errorEle = '#ifsc-no';
      checkPass = false;
    }

    if (!confirmBankAccNumber) {
      vendorError.confirmBankAccNumberErr =
        'Please confirm bank account number';
      errorEle = '#confirm-acc-no';
      checkPass = false;
    }
    if (!bankAccNumber) {
      vendorError.bankAccNumberErr = 'Please enter bank account number';
      errorEle = '#acc-no';
      checkPass = false;
    }
    if (accNoMatchFail) {
      vendorError.confirmBankAccNumberErr =
        "Bank Account number and Confirm Bank Account Number don't match. Please re-enter";
      errorEle = '#confirm-acc-no';
      checkPass = false;
    }
    if (!beneficiaryName) {
      vendorError.beneficiaryNameErr = 'Please enter beneficiary name';
      errorEle = '#beneficiary-name';
      checkPass = false;
    }
    if (!emailId || !emailRegex.test(emailId)) {
      vendorError.emailIdErr = 'Please enter valid email id';
      errorEle = '#email-id';
      checkPass = false;
    }
    if (!contactNumber || contactNumber.toString().length !== 10) {
      vendorError.contactNumberErr = 'Please enter valid contact number';
      errorEle = '#contact-no';
      checkPass = false;
    }
    if (!contactPerson) {
      vendorError.contactPersonErr = 'Please enter contact name';
      errorEle = '#contact-name';
      checkPass = false;
    }
    if (
      typeof city === 'string' ? city.length === 0 : city?.name?.length === 0
    ) {
      vendorError.cityErr = 'Please enter city';
      errorEle = '#city-name';
      checkPass = false;
    }
    if (gstFetched !== 'fetched' && !address) {
      vendorError.addressErr = 'Please enter valid address';
      errorEle = '#address';
      checkPass = false;
    }
    if (!pincode || !pinRegex.test(pincode)) {
      vendorError.pincodeErr = 'Please enter valid pincode';
      errorEle = '#pincode-no';
      checkPass = false;
    }
    // if (gstFetched !== 'fetched' && (!panNo || !panNoRegex.test(panNo))) {
    //   vendorError.panNoErr = 'Please enter PAN';
    //   errorEle = '#pan-no';
    //   checkPass = false;
    // }
    if (!registeredName) {
      vendorError.registeredNameErr = 'Please enter registered name';
      errorEle = '#registered-name';
      checkPass = false;
    }
    if (!displayName) {
      vendorError.displayNameErr = 'Please enter display name';
      errorEle = '#display-name';
      checkPass = false;
    }
    if (!identificationId) {
      vendorError.identificationIdErr = `Please enter ${
        isVendorRegistered ? 'GSTIN' : 'PAN'
      }`;
      errorEle = '#gstin';
      checkPass = false;
    }

    if (!checkPass) {
      this.handleScroll(errorEle);
      this.setState({ vendorError });
    }
    return checkPass;
  };

  appendData = finalObj => {
    const {
      isVendorRegistered,
      gstFetched,
      panNo,
      identificationId,
      displayName,
      contactNumber,
      emailId,
      city,
      address,
      states,
      bankAccNumber,
      ifscNumber,
      beneficiaryName,
      contactPerson,
      pincode,
      registeredName,
      file: { newFiles = [] },
      cityText,
    } = this.state;
    const { match: { params: { viewType } = {} } = {} } = this.props;
    const isGstinFlow =
      viewType === 'editVendor'
        ? isVendorRegistered
        : isVendorRegistered && gstFetched === 'fetched';
    finalObj.append('is_gstin_flow', isGstinFlow);
    finalObj.append(
      'identification_id',
      isGstinFlow ? identificationId : panNo,
    );
    finalObj.append('identification_details', JSON.stringify({}));
    finalObj.append('display_name', displayName);
    finalObj.append('vendor_name', registeredName);
    finalObj.append('email_id', emailId);
    finalObj.append('mobile_number', contactNumber);
    finalObj.append('address', address || '');
    finalObj.append('city', typeof city === 'string' ? city : city?.name);
    finalObj.append('state', states);
    finalObj.append('account_number', bankAccNumber);
    finalObj.append('ifsc_code', ifscNumber);
    finalObj.append('beneficiary_name', beneficiaryName);
    finalObj.append('contact_name', contactPerson);
    finalObj.append('pincode', pincode);
  };

  createParams = () => {
    const {
      file: { newFiles = [], oldFiles = [] },
    } = this.state;
    const finalObj = new FormData();
    // for (let i = 0; i < newFiles.length; i++) {
    //   finalObj.append('cancelled_cheque_copy', newFiles[i]);
    // }
    finalObj.append('file_link', oldFiles[0]);
    this.appendData(finalObj);
    return finalObj;
  };

  createUpdateVendorParams = () => {
    const { editVendorDetails } = this.props;
    const {
      file: { newFiles = [], oldFiles = [] },
    } = this.state;
    const {
      vendor_id,
      bank_details: { cancelled_cheque_copy = '' } = {},
    } = editVendorDetails;
    const finalObj = new FormData();
    finalObj.append('id', vendor_id);
    if (cancelled_cheque_copy && oldFiles.length === 0 && newFiles.length > 0) {
      finalObj.append('delete_item', JSON.stringify([0]));
      finalObj.append('attachment_0', newFiles[0]);
    }
    finalObj.append('file_link', oldFiles[0]);
    this.appendData(finalObj);
    return finalObj;
  };

  handleActionClick = typeOfAction => {
    const {
      saveVendorDetails,
      updateVendorDetails,
      match: { params: { viewType } = {} } = {},
    } = this.props;
    const isValidated = this.checkValidation(typeOfAction);
    if (
      isValidated &&
      ['Submit', 'Save'].includes(typeOfAction) &&
      viewType !== 'editVendor'
    ) {
      saveVendorDetails(this.createParams(), typeOfAction === 'Submit');
    } else if (isValidated && viewType === 'editVendor') {
      updateVendorDetails(
        this.createUpdateVendorParams(),
        typeOfAction === 'Submit',
      );
    }
  };

  _autoCompleteChange = (type, event, value) => {
    this.setState({ [type]: value, states: value.state, cityText: value.name });
  };

  _fieldOnChange = (type, value) => {
    const { vendorError } = this.state;
    vendorError.cityErr = '';

    if (value.length >= 3) {
      this.autocompleteSearchCityOnlyThrottled(value);
    }
    this.setState({
      [type]: value.length >= 3,
      vendorError,
    });
  };

  _autocompleteSearchCityOnly = searchText => {
    const obj = {
      query: searchText,
    };
    this.props.getCityState(obj);
  };

  handlePreventCopyPaste = id => {
    const myInput = document.getElementById(id);
    if (myInput) {
      myInput.oncopy = e => e.preventDefault();
      myInput.onpaste = e => e.preventDefault();
    }
  };

  handleIfscValidation = ifscNumber => {
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return !(!ifscNumber || !ifscRegex.test(ifscNumber));
  };

  handleSubmitVendor = () => {
    const {
      submitVendor,
      match: { params: { vendorId } = {} } = {},
    } = this.props;
    submitVendor({ vendor_id: vendorId });
  };

  handleResetCity = () => {
    this.setState({ city: {}, states: '', searchCity: false });
    this.props.setCityState([]);
  };

  render() {
    const {
      identificationId,
      gstFetched,
      isVendorRegistered,
      displayName,
      registeredName,
      panNo,
      address,
      city,
      states,
      pincode,
      emailId,
      contactPerson,
      contactNumber,
      beneficiaryName,
      bankAccNumber,
      confirmBankAccNumber,
      ifscNumber,
      declaration,
      file,
      countryCode,
      searchCity,
      vendorError,
      openDialogbox,
      showCancelConfirmation,
      isIfscCorrect,
      shimmer,
      ocrDetails,
    } = this.state;
    const {
      countryCodes,
      cityState,
      vendorList = [],
      match: { params: { vendorId, viewType } = {} } = {},
      editVendorDetails = {},
      workflowDetails = {},
      setVendorDetails,
      workflowVendorContainerAction,
      workflowVendorContainerCommentAction,
      comment,
      getWorkflowComments,
      userInfo,
      getBankDetailsThroughIfsc,
      ifscBankDetails,
      location: { state = {} },
      ocrData,
    } = this.props;
    const codes = (countryCodes || []).map(item => ({
      text: item.country_code,
      value: item.country_code,
    }));

    const showShimmer = Object.keys(editVendorDetails).length === 0;
    return (
      <>
        {' '}
        <GenericHeader
          title={
            viewType === 'detail'
              ? 'Vendor Details'
              : viewType === 'editVendor'
              ? 'Edit Vendor'
              : 'New Vendor'
          }
          showBreadcrumbs={false}
          headerconfig={this.getHeaderConfig()}
          onButtonClick={this.onButtonClick}
          from="vendor"
          showStatus={viewType === 'detail'}
          data={editVendorDetails?.approval_status}
        />
        <Grid
          container
          alignItems="center"
          justify="center"
          className="create-vendor-container margin-b-70 padding-b-30"
        >
          <ActionConfirmation
            btn2Action={this.handleDialogActionClick}
            openDialogbox={openDialogbox}
            onDialogboxClose={() => this.setState({ openDialogbox: false })}
            dialogTitle="Delete Vendor"
            dialogBody="Are you sure you want to delete the vendor?"
          />
          {['detail', 'editVendor'].includes(viewType) && showShimmer ? (
            <VendorShimmer />
          ) : viewType === 'detail' ? (
            <Grid item xs={24} sm={16} md={16} xl={16} lg={16}>
              <VendorDetailedView
                vendorDetails={editVendorDetails}
                viewType={viewType}
                workflowDetails={workflowDetails}
                workflowVendorContainerAction={workflowVendorContainerAction}
                workflowVendorContainerCommentAction={
                  workflowVendorContainerCommentAction
                }
                callVendorUpdate={this.handleDialogActionClick}
                getWorkflowComments={getWorkflowComments}
                comment={comment}
                userInfo={userInfo}
                submitVendor={this.handleSubmitVendor}
                from={state?.urlType ? 'workflow' : 'nonworkflow'}
                showCancelConfirmation={showCancelConfirmation}
              />
            </Grid>
          ) : (
            <Grid
              item
              className="margin-t-118"
              xs={22}
              sm={18}
              md={16}
              xl={16}
              lg={16}
            >
              <GstinDetails
                isVendorRegistered={isVendorRegistered}
                identificationId={identificationId}
                handleChange={this.handleChange}
                handleVendorRegisteration={this.handleVendorRegisteration}
                handleFetchGST={this.handleFetchGST}
                drawCardUI={this.drawCardUI}
                gstFetched={gstFetched}
                vendorError={vendorError}
              />
              <VendorDetails
                gstFetched={gstFetched}
                displayName={displayName}
                registeredName={registeredName}
                panNo={panNo}
                identificationId={identificationId}
                address={address}
                city={city}
                states={states}
                pincode={pincode}
                handleChange={this.handleChange}
                drawCardUI={this.drawCardUI}
                _autoCompleteChange={this._autoCompleteChange}
                _fieldOnChange={this._fieldOnChange}
                cityState={cityState}
                searchCity={searchCity}
                isVendorRegistered={isVendorRegistered}
                vendorError={vendorError}
                viewType={viewType}
                handleResetCity={this.handleResetCity}
              />
              <ContactDetails
                emailId={emailId}
                contactPerson={contactPerson}
                contactNumber={contactNumber}
                handleChange={this.handleChange}
                drawCardUI={this.drawCardUI}
                codes={codes}
                countryCode={countryCode}
                vendorError={vendorError}
              />
              <BankAccountDetails
                beneficiaryName={beneficiaryName}
                bankAccNumber={bankAccNumber}
                confirmBankAccNumber={confirmBankAccNumber}
                ifscNumber={ifscNumber}
                declaration={declaration}
                file={file}
                isIfscCorrect={isIfscCorrect}
                handleChange={this.handleChange}
                onUploadFile={this.onUploadFile}
                onDeleteFile={this.onDeleteFile}
                drawCardUI={this.drawCardUI}
                vendorError={vendorError}
                getBankDetailsThroughIfsc={getBankDetailsThroughIfsc}
                ifscBankDetails={ifscBankDetails}
                handlePreventCopyPaste={this.handlePreventCopyPaste}
                handleIfscValidation={this.handleIfscValidation}
                handleIfsc={this.handleIfsc}
                shimmer={shimmer}
                // ifscCode={ocrData?.ifsc_code}
                ocrDetails={ocrDetails}
              />

              <Declaration
                onClick={this.handleChange}
                id="vendor-declaration"
                value={declaration}
                error={vendorError.declarationErr}
                checkBoxWrapperStyle={{
                  marginBottom: '20px',
                  paddingBottom: vendorError.declarationErr ? '60px' : '',
                }}
              />

              <BottomActions
                handleActionClick={val => this.handleActionClick(val)}
                from="Vendor"
                validation={this.checkValidation}
                actionMap={{ Save: 'Save', Submit: 'Submit' }}
                showCancelConfirmation={showCancelConfirmation}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

const GstinDetails = props => {
  const {
    isVendorRegistered,
    identificationId,
    handleChange,
    handleVendorRegisteration,
    handleFetchGST,
    drawCardUI,
    gstFetched,
    vendorList = [],
    vendorError: { identificationIdErr },
  } = props;

  const btnText = ['not_fetched', 'fetch_failed'].includes(gstFetched) ? (
    <>Verify</>
  ) : gstFetched === 'fetching' ? (
    <>
      Verifying <Spinner height={12} width={12} className="margin-l-5" />
    </>
  ) : (
    <div className="flex-vertical-center">
      Verified{' '}
      <Icons
        type="tick"
        enableCircle
        size="8"
        className="border-white-imp margin-l-5"
      />
    </div>
  );
  const gstFetchedCond = gstFetched === 'fetched';
  const gstFetchFailedCond = gstFetched === 'fetch_failed';
  const gstinCardContent = (
    <Grid container className="padding-lr-100 padding-b-30">
      <Grid item>
        <div className="fw-400 letter-spacing-25 padding-t-30 padding-b-6">
          Is your vendor GSTIN registered?
        </div>
        <RadioGroup
          value={isVendorRegistered}
          onClick={value => handleVendorRegisteration(value)}
          radioLabelPlacement="right"
          direction="horizontal"
          radioButtonWrapperStyle={{ marginRight: '20px' }}
          radioButton={[
            { id: 'yes', value: true, label: 'Yes' },
            { id: 'no', value: false, label: 'No' },
          ]}
        />
      </Grid>
      <h4 className="fw-500 letter-spacing-25">
        Enter the Vendor {isVendorRegistered ? 'GSTIN' : 'PAN'} for faster
        capturing of the vendor details
      </h4>
      <Grid
        container
        alignItems="flex-start"
        className={gstFetchedCond && 'gstin-input'}
      >
        <TextInput
          floatingLabelText={isVendorRegistered ? 'GSTIN' : 'PAN'}
          id="gstin"
          hintText={`Type ${isVendorRegistered ? 15 : 10} digit ${
            isVendorRegistered ? 'GSTIN' : 'PAN'
          } here`}
          value={identificationId}
          required
          type="text"
          clearMargin
          iconPlacement={gstFetchFailedCond && 'right'}
          iconType={gstFetchFailedCond && 'error'}
          iconClass={gstFetchFailedCond && 'alert-red-color'}
          errorType={
            gstFetchFailedCond || identificationIdErr
              ? 'error'
              : gstFetchedCond
              ? 'success'
              : ''
          }
          iconTooltip={`The ${
            isVendorRegistered ? 'GSTIN' : 'PAN'
          } is incorrect. Try again.`}
          iconTooltipClass="gstin-error-tooltip"
          customInputParentStyle={{ width: '300px' }}
          onChange={(e, val) => handleChange('identificationId', val)}
          errorText={
            gstFetched === 'fetched'
              ? `We have autofilled your form based on your ${
                  isVendorRegistered ? 'GSTIN' : 'PAN'
                }`
              : identificationIdErr || ''
          }
          errorClassName={!identificationIdErr && 'alert-green-color'}
        />
        <Button
          type="button"
          text={btnText}
          className="fetch-btn margin-l-20"
          size="small"
          onClick={handleFetchGST}
          disabled={!identificationId}
        />
      </Grid>
    </Grid>
  );

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        handleFetchGST();
      }}
    >
      {drawCardUI('GSTIN Details', 1, gstinCardContent)}
    </form>
  );
};

const VendorDetails = props => {
  const {
    gstFetched,
    displayName,
    registeredName,
    panNo,
    identificationId,
    address,
    city,
    states,
    pincode,
    handleChange,
    handleResetCity,
    drawCardUI,
    pinErr,
    _autoCompleteChange,
    _fieldOnChange,
    cityState,
    searchCity,
    isVendorRegistered,
    viewType,
    vendorError: {
      displayNameErr,
      registeredNameErr,
      panNoErr,
      pincodeErr,
      addressErr,
      cityErr,
    },
  } = props;
  const dataSourceConfig = {
    text: 'name',
    value: 'name',
  };
  const objTypeCity = typeof city === 'object';
  const isCity = objTypeCity ? Object.keys(city).length > 0 : city.length > 0;
  const cityCheck = isCity ? city : '';
  const cityData =
    !cityState.length && cityCheck
      ? [objTypeCity ? cityCheck : { name: cityCheck }]
      : cityState; // creating dummy data for dropdown in case the city is prefetched from BE
  const cityVal =
    !cityState.length && !objTypeCity ? { name: cityCheck } : cityCheck; // creating value according to dummy dropdown data, since city will be string in case of edit
  const disablingCond =
    (viewType === 'editVendor' &&
      identificationId?.length !== 0 &&
      isVendorRegistered) ||
    (gstFetched === 'fetched' && isVendorRegistered);
  const vendorCardContent = (
    <Grid container className="padding-lr-100">
      <Grid item>
        <TextInput
          id="display-name"
          floatingLabelText="Vendor Display Name"
          hintText="Type an alias for registered name"
          value={displayName}
          type="text"
          required
          onChange={(e, val) => handleChange('displayName', val)}
          errorType={displayNameErr && 'error'}
          errorText={displayNameErr}
        />
        <TextInput
          id="registered-name"
          floatingLabelText="Registered Name"
          hintText="Type Registered Name"
          value={registeredName}
          type="text"
          required
          onChange={(e, val) => handleChange('registeredName', val)}
          disabled={gstFetched === 'fetched'}
          errorType={registeredNameErr && 'error'}
          errorText={registeredNameErr}
        />
        <TextInput
          id="pan-no"
          floatingLabelText="PAN"
          hintText="Type PAN No."
          value={
            gstFetched === 'fetched' && identificationId.length === 15
              ? identificationId?.substring(2, 12)
              : panNo
          }
          type="text"
          iconType={
            gstFetched === 'fetched' &&
            !panNoErr &&
            identificationId &&
            'tick-circle'
          }
          iconClass={
            gstFetched === 'fetched' &&
            !panNoErr &&
            identificationId &&
            'alert-green-color'
          }
          // required
          // maxLength={10}
          // errorType={panNoErr && 'error'}
          // errorText={panNoErr}
          // onChange={(e, val) =>
          //   handleChange(
          //     gstFetched === 'fetched' ? 'identificationId' : 'panNo',
          //     val,
          //   )
          // }
          disabled
        />
        <Grid item alignItems="baseline" className="address-wrapper">
          <TextInput
            id="pincode-no"
            floatingLabelText="Pincode"
            hintText="Pincode"
            value={pincode}
            required
            isNumberType
            maxLength={6}
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            errorType={pincodeErr && 'error'}
            errorText={pincodeErr}
            onChange={(e, val) => handleChange('pincode', val)}
            disabled={disablingCond}
            clearMargin
          />
          <TextInput
            id="address"
            floatingLabelText="Address"
            hintText="Type Address"
            value={address}
            type="text"
            required
            onChange={(e, val) => handleChange('address', val)}
            disabled={gstFetched === 'fetched' && isVendorRegistered}
            clearMargin
            errorType={addressErr && 'error'}
            errorText={addressErr}
          />
        </Grid>
        <Grid item alignItems="baseline" className="address-wrapper">
          {/* {(gstFetched === 'fetched' && isVendorRegistered) || viewType === 'editVendor' ? (
            <TextInput
              id="city-name"
              floatingLabelText="City"
              hintText="Type City Name"
              value={city}
              type="text"
              required
              onChange={(e, val) => handleChange('city', val)}
              disabled={disablingCond}
              errorType={cityErr && 'error'}
              errorText={cityErr}
            />
          ) : ( */}
          <Dropdown
            id="city-name"
            preventDropdownClosingElement="#City"
            isSearchableInput
            asyncSearch
            labelText="City"
            // value={city}
            value={cityVal}
            isRequired
            onChange={(event, index, value) =>
              _autoCompleteChange('city', event, value)
            }
            handleAsyncSearch={(event, index, value) =>
              _fieldOnChange('searchCity', event, value)
            }
            // data={cityState}
            data={cityData}
            isLoader={searchCity && !isCity}
            dropdownInputHintText="Enter 3 letters to search for a city"
            customDropdownStyle={{ marginBottom: '20px' }}
            dataConfig={dataSourceConfig}
            valueType="object"
            disabled={disablingCond}
            errorType={cityErr && 'error'}
            errorText={cityErr}
            extraIcon={isCity ? 'cross-fill' : ''}
            onExtraIconClick={handleResetCity}
          />
          {/* )} */}
          <TextInput
            id="state-name"
            floatingLabelText="State"
            hintText="Type State Name"
            value={states}
            type="text"
            required
            onChange={(e, val) => handleChange('states', val)}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>
  );
  return drawCardUI('Vendor Details', 2, vendorCardContent);
};

const ContactDetails = props => {
  const {
    emailId,
    contactPerson,
    contactNumber,
    handleChange,
    drawCardUI,
    codes,
    countryCode,
    vendorError: { contactPersonErr, contactNumberErr, emailIdErr },
  } = props;
  const contactCardContent = (
    <div className="padding-lr-100">
      <TextInput
        id="contact-name"
        floatingLabelText="Name"
        hintText="Type name"
        value={contactPerson}
        type="text"
        required
        errorType={contactPersonErr && 'error'}
        errorText={contactPersonErr}
        onChange={(e, val) => handleChange('contactPerson', val)}
        clearMargin
        customInputParentStyle={{ marginTop: '30px' }}
      />
      <Grid item className="d-flex contact-details-wrapper">
        <Dropdown
          id="select-currency-dropdown"
          isRequired
          // autoFocus
          labelText="Code"
          // dropdownInputHintText="Select currency"
          value={countryCode || '+91'}
          onChange={(e, i, dt) => handleChange('countryCode', dt)}
          data={codes}
          customDropdownStyle={{}}
          customDropdownContainerStyle={{ minWidth: '100px' }}
        />
        <TextInput
          id="contact-no"
          floatingLabelText="Contact Number"
          hintText="Type contact number"
          value={contactNumber}
          isNumberType
          maxLength={10}
          required
          errorType={contactNumberErr && 'error'}
          errorText={contactNumberErr}
          onChange={(e, val) => handleChange('contactNumber', val)}
        />
        <TextInput
          id="email-id"
          floatingLabelText="Email ID"
          hintText="Type email ID"
          value={emailId}
          type="text"
          errorType={emailIdErr && 'error'}
          errorText={emailIdErr}
          required
          onChange={(e, val) => handleChange('emailId', val)}
        />
      </Grid>
    </div>
  );
  return drawCardUI('Contact Details', 3, contactCardContent);
};

const BankAccountDetails = props => {
  const {
    beneficiaryName,
    bankAccNumber,
    confirmBankAccNumber,
    ifscNumber,
    handleChange,
    file,
    onUploadFile,
    onDeleteFile,
    drawCardUI,
    getBankDetailsThroughIfsc,
    ifscBankDetails,
    handlePreventCopyPaste,
    handleIfscValidation,
    isIfscCorrect,
    handleIfsc,
    shimmer,
    ifscCode,
    ocrDetails: {
      ocrBankAccNumber,
      ocrIfscNumber,
      ocrBeneficiaryName,
      ocrConfirmBankAccNumber,
    },
    vendorError: {
      beneficiaryNameErr,
      bankAccNumberErr,
      confirmBankAccNumberErr,
      ifscNumberErr,
      fileErr,
    },
  } = props;
  const drawInstructionUI = text => (
    <div className="upload-instruction font-12 fw-500">{text}</div>
  );
  const accNoMatchFail =
    bankAccNumber &&
    confirmBankAccNumber &&
    bankAccNumber.length <= confirmBankAccNumber.length &&
    bankAccNumber !== confirmBankAccNumber;
  const ifscData = ifscNumber.length === 11 ? ifscBankDetails : null;
  let errorCond = false;
  let noMatchingIfscFound = false;
  if (ifscNumberErr) {
    errorCond = true;
  } else if (ifscNumber.length === 11 && !isIfscCorrect) {
    errorCond = true;
  } else if (ifscNumber.length === 11 && !ifscBankDetails) {
    errorCond = true;
  } else if (ifscNumber.length === 11 && ifscBankDetails?.error?.length > 0) {
    errorCond = true;
    noMatchingIfscFound = true;
  }
  const bankCardContent = (
    <div className="padding-lr-100 padding-b-30">
      <h4 className="fw-400 font-12">
        Upload Cancelled Cheque<span className="alert-red-color">*</span>
      </h4>
      <FileUpload
        id="vendor-file-upload"
        files={file}
        uploadFiles={onUploadFile}
        deleteFiles={onDeleteFile}
        acceptedFiles={[
          'application/pdf',
          'image/heic',
          'image/jpg',
          'image/jpeg',
          'image/png',
          'image/tiff',
          'image/tif',
          'image/bmp',
        ]}
        shimmerStyle={{ width: '345px', height: '170px' }}
        labelText={
          <div className="d-flex flex-direction-column flex-vertical-center">
            <div className="fw-600 d-flex">
              <Icons type="addinsurance" size="small" className="padding-r-6" />{' '}
              Drag & Drop or
            </div>
            <div className="padding-lr-20 padding-tb-10 border-radius-4 purple-border margin-t-12">
              Upload Cancelled Cheque
            </div>
          </div>
        }
        iconType=""
        customIconStyle={{ display: 'none !important' }}
        multiple={false}
        maxAttachment={1}
        variant="tertiary"
        enableLightBox
        // inPlaceAttachment
        shimmer={shimmer}
        shimmerElement={
          <div className="align-center">
            <Icons type="scan" />
            <h3 className="fw-500 font-14 light-black">ScanX in progress</h3>
            <div className="fw-300 font-14 dark-text">
              We are auto-fetching the data...
            </div>
          </div>
        }
        inplaceUploadWrapper={{
          height: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        attachementStyle={{ maxHeight: '200px' }}
        fileWrapperStyle={{
          marginBottom: '20px',
          border: fileErr ? '1px dashed #eb4646' : '',
          color: fileErr ? '#eb4646' : '',
        }}
      />
      {drawInstructionUI(
        '*Maximum file upload: 1 file; Maximum file size:15Mb',
      )}
      {drawInstructionUI('*File types: .png, .pdf, .jpg, .jpeg')}
      <div>
        <TextInput
          id="beneficiary-name"
          floatingLabelText="Beneficiary Name"
          hintText="Enter beneficiary name"
          value={beneficiaryName}
          type="text"
          required={!shimmer}
          errorType={beneficiaryNameErr && 'error'}
          errorText={beneficiaryNameErr}
          onChange={(e, val) => handleChange('beneficiaryName', val)}
          iconType={
            ocrBeneficiaryName && ocrBeneficiaryName === beneficiaryName
              ? 'ocr'
              : ''
          }
          iconImg={
            ocrBeneficiaryName && ocrBeneficiaryName === beneficiaryName
              ? OCRImg
              : ''
          }
          shimmer={!beneficiaryName && shimmer}
          iconTooltip="Auto-fetched via ScanX"
        />
        <TextInput
          id="acc-no"
          floatingLabelText="Bank Account Number"
          hintText="Enter bank account number"
          value={bankAccNumber}
          type="password"
          required
          errorType={bankAccNumberErr && 'error'}
          errorText={bankAccNumberErr}
          onChange={(e, val) => {
            // handlePreventCopyPaste('acc-no');
            handleChange('bankAccNumber', val);
          }}
          iconType={
            ocrBankAccNumber && ocrBankAccNumber === bankAccNumber ? 'ocr' : ''
          }
          iconImg={
            ocrBankAccNumber && ocrBankAccNumber === bankAccNumber ? OCRImg : ''
          }
          shimmer={!bankAccNumber && shimmer}
          iconTooltip="Auto-fetched via ScanX"
        />
        <TextInput
          id="confirm-acc-no"
          floatingLabelText="Confirm Bank Account Number"
          hintText="Enter bank account number"
          value={confirmBankAccNumber}
          type="text"
          required
          errorType={(accNoMatchFail || confirmBankAccNumberErr) && 'error'}
          errorText={
            accNoMatchFail
              ? "Bank Account number and Confirm Bank Account Number don't match. Please re-enter"
              : confirmBankAccNumberErr
          }
          onChange={(e, val) => {
            // handlePreventCopyPaste('confirm-acc-no');
            handleChange('confirmBankAccNumber', val);
          }}
          // iconType={
          //   ocrConfirmBankAccNumber &&
          //   ocrConfirmBankAccNumber === confirmBankAccNumber
          //     ? 'ocr'
          //     : ''
          // }
          // iconImg={
          //   ocrConfirmBankAccNumber &&
          //   ocrConfirmBankAccNumber === confirmBankAccNumber
          //     ? OCRImg
          //     : ''
          // }
        />
        <TextInput
          id="ifsc-no"
          floatingLabelText="IFSC"
          hintText="Enter IFSC code"
          value={ifscNumber}
          maxLength={11}
          errorType={errorCond && 'error'}
          errorText={
            ifscNumberErr ||
            (noMatchingIfscFound
              ? ifscBankDetails.error || ''
              : errorCond
              ? 'Please enter a valid IFSC'
              : '')
          }
          type="text"
          required
          customInputParentStyle={{
            marginBottom: ifscData && isIfscCorrect ? '10px' : '30px',
          }}
          onChange={(e, val) => handleIfsc(e, val)}
          iconType={ocrIfscNumber && ocrIfscNumber === ifscNumber ? 'ocr' : ''}
          iconImg={ocrIfscNumber && ocrIfscNumber === ifscNumber ? OCRImg : ''}
          shimmer={!ifscNumber && shimmer}
          iconTooltip="Auto-fetched via ScanX"
        />
        {ifscData && isIfscCorrect && !errorCond && (
          <div>
            <div className="upload-instruction font-12">
              Branch Name:{' '}
              <span className="fw-500">{ifscData.branch_name}</span>
            </div>
            <div className="upload-instruction font-12">
              Bank Name: <span className="fw-500">{ifscData.bank_name}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
  return drawCardUI('Bank Account Details', 4, bankCardContent);
};

CreateVendor.propTypes = {
  getCountryCodes: PropTypes.func,
  getVendorDetails: PropTypes.func,
  getCityState: PropTypes.func,
  getWorkVendorFlowDetails: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
  setVendorDetails: PropTypes.func,
  vendorList: PropTypes.object,
  editVendorDetails: PropTypes.object,
  ocrData: PropTypes.object,
  updateVendorDetails: PropTypes.func,
  history: PropTypes.object,
  submitVendor: PropTypes.func,
  countryCodes: PropTypes.array,
  cityState: PropTypes.array,
  workflowDetails: PropTypes.object,
  workflowVendorContainerAction: PropTypes.func,
  workflowVendorContainerCommentAction: PropTypes.func,
  comment: PropTypes.string,
  getWorkflowComments: PropTypes.func,
  userInfo: PropTypes.object,
  getBankDetailsThroughIfsc: PropTypes.func,
  ifscBankDetails: PropTypes.object,
  getChequeDetails: PropTypes.func,
  getGstinDetails: PropTypes.func,
  saveVendorDetails: PropTypes.func,
  gstFetchedFailed: PropTypes.bool,
};
CreateVendor.defaultProps = {
  getCountryCodes: () => {},
  getVendorDetails: () => {},
  getCityState: () => {},
  getWorkVendorFlowDetails: () => {},
  updateVendorDetails: () => {},
  match: {},
  location: {},
  history: {},
  setVendorDetails: () => {},
  vendorList: {},
  editVendorDetails: {},
  ocrData: {},
  countryCodes: [],
  cityState: [],
  workflowDetails: {},
  getWorkflowComments: () => {},
  workflowVendorContainerCommentAction: () => {},
  getBankDetailsThroughIfsc: () => {},
  ifscBankDetails: {},
  getChequeDetails: () => {},
  getGstinDetails: () => {},
  saveVendorDetails: () => {},
};
